import { t } from '../../../common/i18n';
import { getDefaultCardContentData, getTierPriceInfoItems } from './ProductOfferingCardContentUtils.js';
import type { ProductCardContentProps } from './types.js';

export const getSoftwareProductCardContent = ({ productOffering }: ProductCardContentProps) => {
  const defaultData = getDefaultCardContentData(productOffering);
  const tierPriceItems = getTierPriceInfoItems(productOffering);

  return {
    subHeader: t.V15A('Elisa'),
    badges: [],
    infoItems: [...defaultData.infoItems, ...tierPriceItems],
  };
};
